import { flatMap } from 'lodash-es';
import { DashboardNotifications, Notification } from "@dev/ee-api/ee-api-models";
import { personaSurveyNotificationNames } from "../constants";

export const findPersonaSurveyNotificationName = (notificationList: Notification[]): DashboardNotifications | undefined => 
    flatMap(notificationList, (notification): DashboardNotifications[] => notification.DashboardNotifications)
        .find(notification => personaSurveyNotificationNames.includes(notification));
